import { ZfBox, ZfDivider, ZfLoadingSpinner, ZfTextButton } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { getImageUrlByString } from '../../../../styles/assets/imageMap';
import { useNeedContentContext } from '../../../contexts/need-content-context';
import { useContainerDimensions } from '../../../hooks/useContainerDimensions';
import { TopicListSidebar } from '../components/TopicListSidebar';
import { NeedDetailPanel } from '../panels/NeedDetailPanel';
import { TopicDetailPanel } from '../panels/TopicDetailPanel';

export const TopicScreenNoActiveSession: FunctionComponent = () => {
    const { t, i18n } = useTranslation();
    const containerDimensions = useContainerDimensions();
    const { activeTopic, activeTalkingPoint, activeAdvisoryNeed } = useNeedContentContext();
    const navigate = useNavigate();

    if (!activeTopic) {
        return <ZfLoadingSpinner />;
    }

    return (
        <ZfBox id="topicScreen" style={{ flex: 1 }}>
            <div className="topic-screen" style={{ height: `${containerDimensions.height}px` }}>
                <div className="topic-screen__sidebar">
                    <div className="topic-screen__sidebar__header">
                        <ZfTextButton hierarchy="tertiary" size="small" leading-icon="arrow_back" className="m-auto-0" onClick={() => navigate('..')}>
                            {t('back')}
                        </ZfTextButton>
                        <ZfDivider orientation="vertical" />
                        <h4>{activeTopic.name[i18n.language]}</h4>
                    </div>
                    <h5>{t('titleKeyTopics')}</h5>
                    <TopicListSidebar showLeadingCheckbox={false} />
                </div>
                <div className="topic-screen__panels out-session" style={{ backgroundImage: `url(${getImageUrlByString(activeTopic.key)})` }}>
                    {activeTalkingPoint && <TopicDetailPanel containerDimensionsHeight={containerDimensions.height} />}
                    {activeAdvisoryNeed && <NeedDetailPanel containerDimensionsHeight={containerDimensions.height} hideBackButton={true} />}
                </div>
            </div>
        </ZfBox>
    );
};
